module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.componentClasses,
    on: {
      "click": _vm.clickInput,
      "dragenter": function($event) {
        $event.preventDefault();
        _vm.dndEnter($event)
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dndLeave($event)
      },
      "dragover": function($event) {
        $event.preventDefault(); /* Needed to prevent browser from loading file */
      },
      "drop": function($event) {
        $event.preventDefault();
        _vm.dndDrop($event)
      }
    }
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "disabled": _vm.disabled,
      "multiple": _vm.multiple
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), (_vm.value.length === 0) ? _vm._t("default", [(_vm.multiple) ? _c('div', {
    staticClass: "instructions"
  }, [_vm._v("\n      Drop files here or click to upload.\n    ")]) : _c('div', {
    staticClass: "instructions"
  }, [_vm._v("\n      Drop file here or click to upload.\n    ")])]) : _c('ol', {
    staticClass: "file-list"
  }, _vm._l((_vm.value), function(file) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(file.objectUrl) ? _c('img', {
      attrs: {
        "src": file.objectUrl
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        'auto-hide': !!file.objectUrl
      }
    }, [_c('div', {
      staticClass: "file-info"
    }, [_c('div', {
      staticClass: "file-size"
    }, [_vm._v(_vm._s(_vm.formatFileSize(file.size)))]), _vm._v(" "), _c('div', {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button",
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.removeFiles([file])
        }
      }
    }, [_vm._v("\n            Remove\n          ")])])])])
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d58735d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/file-select/index.vue
// module id = 2106
// module chunks = 2